import { Stack } from "@mui/material";

import { LocationSearch } from "./LocationSearch";
import { SearchForm } from "./search";
import { Location } from "graphql/generated/types";
import { trackingCategory } from "utils/tracking";

type SearchFormWithLocationProps = {
    inputRef?: React.RefObject<HTMLInputElement | null>;
    searchFormRef?: React.RefObject<HTMLInputElement | null>;
    name: string;
    search: string | undefined;
    onChange: (value: string, event: React.ChangeEvent<HTMLInputElement>) => void;
    onLocationChange?: (location: Location | null) => void;
    loading?: boolean;
    inHeading?: boolean;
    className?: string;
    defaultValue?: string;
    placeholder?: string;
} & Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, "onChange">

export const SearchFormWithLocation: React.FC<SearchFormWithLocationProps> = ({ onLocationChange, ...props }) => {
    return (
        <Stack gap={1}>
            <SearchForm {...props} trackClick={{ label: "Event & org search input", category: trackingCategory.searchEventAndOrganisation }} />
            <LocationSearch onChange={onLocationChange} />
        </Stack>
    );
};
